import { type FetchClient, type PageParameters } from './http';
import type { SearchResults, SearchableFields } from './types/search';

export const searchDocuments = ({
  client,
  query,
  scope,
  page = '1',
  size = '20',
  sort,
}: { client: FetchClient; query: string; scope: string; sort?: string } & PageParameters): Promise<SearchResults> => {
  const urlSearchParams = sort ? new URLSearchParams({ page, size, scope, sort }) : new URLSearchParams({ page, size, scope });
  return client.post(`${client.baseUrl}/search?` + urlSearchParams, { query });
};

export const getSearchableFields = ({
  client,
  query = '',
  workspaceIds = [],
  modelIds = [],
  page = '1',
  size = '20',
}: {
  client: FetchClient;
  query: string;
  workspaceIds: string[];
  modelIds: string[];
  page?: string;
  size?: string;
}): Promise<SearchableFields> => {
  return client.get(
    `${client.baseUrl}/searchable-fields?q=${query}&workspaceIds=${workspaceIds.join(',')}&modelIds=${modelIds.join(
      ','
    )}&page=${page}&size=${size}`
  );
};
